import { render, staticRenderFns } from "./MeasureAdditionalDetails.vue?vue&type=template&id=3dea8152&scoped=true"
import script from "./MeasureAdditionalDetails.vue?vue&type=script&lang=js"
export * from "./MeasureAdditionalDetails.vue?vue&type=script&lang=js"
import style0 from "./MeasureAdditionalDetails.vue?vue&type=style&index=0&id=3dea8152&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dea8152",
  null
  
)

export default component.exports